var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state.settings
    ? _c(
        "span",
        {
          staticClass: "dropdown-item-text text-nowrap c-pointer",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.alwaysShowMyBoards,
                expression: "alwaysShowMyBoards"
              }
            ],
            staticClass: "c-pointer",
            attrs: { id: _vm.uid + "alwaysShowMyBoards", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.alwaysShowMyBoards)
                ? _vm._i(_vm.alwaysShowMyBoards, null) > -1
                : _vm.alwaysShowMyBoards
            },
            on: {
              change: function($event) {
                var $$a = _vm.alwaysShowMyBoards,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.alwaysShowMyBoards = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.alwaysShowMyBoards = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.alwaysShowMyBoards = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "c-pointer mb-0",
              attrs: { for: _vm.uid + "alwaysShowMyBoards" }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("kanbanAlwaysShowMyBoards")) + "\n  "
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }